import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import useGetVsic from '../../../../common/category/useGetVsic'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { selectCompanyInfo } from '../../../common/header/companyInfo/store/slice'
import { selectCompareIndustry } from '../store/slice'
import { SelectCustomIndustry } from './IndustrySeclectCustom'

export const CompareIndustry = ({
  inputStyle,
  isDynamicReport,
  setValue,
  keySetting,
  setting,
}) => {
  const { vsics } = useGetVsic()

  const compareIndustry = useSelector(selectCompareIndustry)
  const { companyType } = useSelector(selectCompanyInfo)

  const placeholder = UseI18n('companyAnalysis.SELECT_COMPARING_INDUSTRY')

  return (
    <>
      <Translate
        value={'companyAnalysis.industryAnalysis.COMPARING_INDUSTRY'}
        style={{ width: isDynamicReport ? 150 : 'auto' }}
      />

      <SelectCustomIndustry
        data={isDynamicReport ? setting[keySetting] : compareIndustry}
        vsics={vsics}
        companyType={companyType}
        keyItem={'compareIndustry'}
        borderColor={'#E6964C'}
        customWidthDropdown={230}
        inputStyle={inputStyle}
        keySettingDynamicReport={keySetting}
        setValueDynamicReport={setValue}
        placeholder={placeholder}
        isDynamicReport={isDynamicReport}
      />
    </>
  )
}
